import templateStr from 'text!./pa-driver-year-licensed.html';
import ctrl from './PADriverYearLicensedCtrl';

class PADriverYearLicensed {

    constructor() {
        this.restrict = 'E';
        this.template = templateStr;
        this.scope = {
            label: '@',
            model: '=',
            placeholder: '@',
            tooltip: '=?'
        };
        this.controller = ctrl;
    }
}
export default PADriverYearLicensed;